declare global {
  interface Window {
    acko_analytics: any;
  }
}

export function waitForAnalyticsLoad() {
  return new Promise((resolve) => {
    const resolver = () => {
      if (
        // @ts-ignore
        window?.acko_analytics && window?.acko_analytics?.anonymousId !== undefined
      ) {
        resolve(void 0);
      } else {
        window.setTimeout(resolver, 300);
      }
    };
    setTimeout(resolver, 300);
  });
}
